import { HCP_SPECIALTY_SECONDARY } from '@/api/hcp';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { SECONDARY_SPECIALTY_FILTER_LIMIT } from '../../filterDefaultLimits';

const TA_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.hcp_specialty_global_secondary`],
  limit: SECONDARY_SPECIALTY_FILTER_LIMIT,
});

const secondarySpecialtyFilterConfig: FilterConfigDynamic = {
  label: 'global.filters.formControls.hcpSecondarySpecialityLabel',
  sourceCube: HCP_SPECIALTY_SECONDARY,
  defaultValue: [],
  getOptionsQuery: TA_OPTIONS,
  mapResult: mapDimensionToOption(`${HCP_SPECIALTY_SECONDARY}.hcp_specialty_global_secondary`),
  type: 'multiselect',
  clearable: true,
  placeholder: 'global.filters.formControls.hcpSecondarySpecialityPlaceholder',
  searchable: true,
  applyFilter: filterValue => {
    return {
      member: `${HCP_SPECIALTY_SECONDARY}.hcp_specialty_global_secondary`,
      operator: 'equals',
      values: [...(filterValue as string[])],
    };
  },
};

export default secondarySpecialtyFilterConfig;
